// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let MatchingStatusUpdater = require("./MatchingStatusUpdater.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let RenewRentalPropertyMutation_graphql = require("../../../__generated__/RenewRentalPropertyMutation_graphql.bs.js");

let convertVariables = RenewRentalPropertyMutation_graphql.Internal.convertVariables;

let convertResponse = RenewRentalPropertyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = RenewRentalPropertyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, RenewRentalPropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, RenewRentalPropertyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function use$1(propertyId, propertyNodeId, handleRenewingError, updateMatchingStatus) {
  let match = use();
  let mutate = match[0];
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let fire = () => mutate({
    propertyId: propertyId
  }, undefined, undefined, undefined, (param, param$1) => {
    let renewRentalProperty = param.renewRentalProperty;
    if (renewRentalProperty !== undefined && renewRentalProperty.__typename === "RentalPropertyRenewed") {
      if (updateMatchingStatus) {
        let extra = "IN_PROGRESS";
        return MatchingStatusUpdater.update(environment, propertyNodeId, "RentalPropertyV5", extra);
      } else {
        return;
      }
    } else {
      return handleRenewingError();
    }
  }, param => handleRenewingError(), undefined);
  return [
    fire,
    match[1]
  ];
}

exports.Mutation = Mutation;
exports.use = use$1;
/* commitMutation Not a pure module */
